import QuestionModel from "../QuestionModel";

export default class QuestionModule {
    constructor() {
    }

    create(data) {
        return new QuestionModel(
            data.module,
            data.type,
            data.view,
            data.input,
            data.range,
            data.template || "generic/default",
            data.difficulty
        );
    }

    generateOptions() {
        // override
    }
}

QuestionModule.MODULE_TUTORIAL              = "tutorial";
QuestionModule.MODULE_ARITHMETIC            = "arithmetic";
QuestionModule.MODULE_ALGEBRA               = "algebra";
QuestionModule.MODULE_PLACE_VALUE           = "place_value";
QuestionModule.MODULE_FRACTION_ARITHMETIC   = "fraction_arithmetic";
QuestionModule.MODULE_ROMAN_ARITHMETIC      = "roman_arithmetic";
QuestionModule.MODULE_SORTING               = "sorting";
QuestionModule.MODULE_SHAPES                = "place_value";
QuestionModule.MODULE_VISUAL                = "visual";
QuestionModule.MODULE_BOOLEAN               = "boolean";
QuestionModule.MODULE_SEQUENCE              = "sequence";
QuestionModule.MODULE_EXPONENT              = "exponent";
QuestionModule.MODULE_MEASUREMENT           = "measurement";
QuestionModule.MODULE_RATIO                 = "ratio";
QuestionModule.MODULE_STATS                 = "statistics";
QuestionModule.MODULE_MULTIPLES             = "multiples";
QuestionModule.MODULE_SUM                   = "sum";
QuestionModule.MODULE_SHAPES                = "shapes";
QuestionModule.MODULE_STATIC                = "static";
QuestionModule.MODULE_TIMES_TABLE           = "times_table";
